import { render } from "./index.vue?vue&type=template&id=3241a4ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3241a4ee&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/akc-mallrobot-akc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3241a4ee"]])

export default __exports__